module.exports = __webpack_public_path__ + "img/room-2.d8196a6c.jpg";